<div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
  <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px">
    <div fxFlex>Generate Audio By Text</div>
    <button mat-icon-button [mat-dialog-close]="false" class="button-40">
      <mat-icon>close</mat-icon>
    </button>
  </h1>
  <mat-dialog-content style="display: flex; align-items: stretch">
    <div fxFlex class="stretched-container">
      <form
        [formGroup]="form"
        fxLayout="column"
        fxLayoutAlign="space-around stretch"
        novalidate
        (ngSubmit)="onSubmit()"
      >
        <app-mat-simple-select
          formControlName="language"
          label="Language"
          [selectItems]="languages"
        ></app-mat-simple-select>
        <app-mat-simple-select formControlName="voice" label="Voice" [selectItems]="voices"></app-mat-simple-select>
        <app-mat-textarea-input formControlName="text" label="Text" [rows]="5"></app-mat-textarea-input>

        <button
          type="button"
          mat-raised-button
          color="primary"
          [promiseBtn]="buttonPreviewPromise"
          (click)="onPreviewClick(true, false)"
        >
          Generate
        </button>

        <div style="display: inline-block; width: 100%; padding: 5px; background-color: transparent; height: 60px">
          <audio #audioPreview controls></audio>
        </div>
      </form>
    </div>
  </mat-dialog-content>

  <div mat-dialog-actions style="justify-content: flex-end">
    <button type="button" mat-stroked-button color="primary" (click)="onSubmit()" [disabled]="submitted">Save</button>
    <button type="button" mat-stroked-button [mat-dialog-close]="false">Close</button>
  </div>
</div>
